export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20composition%20with%20flowing%20fabric%20like%20textures%20in%20warm%20amber%20sand%20and%20ivory%20tones%20creating%20a%20smooth%20undulating%20surface%20gentle%20lighting%20transitions%20minimalist%20elegant%20background%20no%20objects%20just%20texture%20and%20tone&width=1400&height=600&seq=cta-bg-section-v2-2026&orientation=landscape"
            alt="Warm abstract background with flowing textures"
            className="w-full h-[350px] md:h-[420px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/45"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p className="text-sm md:text-base text-background-50/80 font-medium uppercase tracking-widest mb-4">
              Ready to Start?
            </p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight max-w-2xl">
              Experience the{' '}
              <em className="italic text-accent-300">ItaobuySpreadsheet</em>
              {' '}Difference
            </h2>
            <p className="mt-4 text-base md:text-lg text-background-50/80 max-w-xl leading-relaxed">
              Join thousands of international shoppers who have already made the switch to transparent, spreadsheet-based ordering from China&apos;s top marketplaces.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 inline-flex items-center px-10 py-4 text-base font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}